import { render, staticRenderFns } from "./PasienMeninggal.vue?vue&type=template&id=5aba471f"
import script from "./PasienMeninggal.vue?vue&type=script&lang=js"
export * from "./PasienMeninggal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aba471f')) {
      api.createRecord('5aba471f', component.options)
    } else {
      api.reload('5aba471f', component.options)
    }
    module.hot.accept("./PasienMeninggal.vue?vue&type=template&id=5aba471f", function () {
      api.rerender('5aba471f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/PasienMeninggal.vue"
export default component.exports